import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray, FormGroup, AbstractControl, FormArray, FormControl } from "@angular/forms";
import "ag-grid-angular";
import * as moment from 'moment';

import "ag-grid-angular";
import 'ag-grid-community/dist/styles/ag-grid.css';
import { AccessoryViewModel, BankPortalService } from '../../../web-api-client';

@Component({
  selector: 'merchant-accessories-request',
  templateUrl: './merchant-accessories-request.component.html'
})
export class MerchantAccessoriesRequest implements OnInit {
  accessoriesRequestForm: FormGroup<{
    itemRows: FormArray<AbstractControl<{
      accessoryId : FormControl<string>,
      quantity : FormControl<string>
      contactPerson: FormControl<string>
    }>>
  }>;
  submitted = false;
  columnDefs: any[] = [];
  rowData = [];
  editMode!: true;
  BankBranchEditForm!: UntypedFormGroup;
  showModelEditBox: boolean = false;
  loadingIndicator!: boolean;
  date:any;
  accessoriesList: AccessoryViewModel[] = [];
  constructor(
    private formBuilder: UntypedFormBuilder,
    private _bankPortal: BankPortalService
) {
    this.accessoriesRequestForm = this.formBuilder.group(
      {
        itemRows: this.formBuilder.array([this.initItemRows()])
      });
  }

  ngOnInit() {
      this.loadTerminalData();
    
  
    
  }
  get itemRows(): UntypedFormArray {
    return this.accessoriesRequestForm.get('itemRows') as UntypedFormArray;
  }
 
  initItemRows() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      inventoryId: ['', [Validators.required]],
      quantity: ['', [Validators.required]],
      contactPerson:['',[Validators.required]],
      // contactNo: ['', [Validators.required]],
     contactNo : [null,[Validators.required, Validators.pattern("^\/?((\/?[9]+[0-9]{9}))*\/?\/?((\/?(\/?[0-9]{9})))*\/?")]],
      remarks:['',[Validators.required]]
    });
}
  get f() { return this.accessoriesRequestForm.controls; }
 
  addNewRow() {
    // control refers to your form array
    const control = <UntypedFormArray>this.accessoriesRequestForm.controls['itemRows'];
    //add new formgroup
    control.push(this.initItemRows());
  }
  deleteAccesoriesRequestRow(index: number) {
    // control refers to your formarray
    const control = <UntypedFormArray>this.accessoriesRequestForm.controls['itemRows'];
    // remove the chosen row
    control.removeAt(index);
  }
 
  loadTerminalData() {
    //this.inventory.hasSerialNo = true;
    this._bankPortal.bankPortal_GetSparesDataInfo().subscribe(results => this.onDataLoadSuccessfulInventory(results), error => this.onDataLoadFailedInventory(error));
  }
  onDataLoadSuccessfulInventory(accessory: AccessoryViewModel[]) {
    this.accessoriesList = accessory;
  }
  onDataLoadFailedInventory(error: any) {
    // this.alertService.stopLoadingMessage();
    //this.loadingIndicator = false;

  }
}